import {Body2, DisplayH1} from "pu-crossproduct-components/build/components/Atoms/Type";
import React from "react";
import {InformatDefaultPage} from "../../../04templates/informat/defaultPage/InformatDefaultPage";
import {Trans, useTranslation} from "react-i18next";
import {GridContainer, GridItem, GridRow} from "pu-crossproduct-components/build/components/Atoms/Grid";

export const Informat404: React.FC = props => {
    const {t} = useTranslation();
    return <InformatDefaultPage>
        <GridContainer>
            <GridRow>
                <GridItem col={0} laptop={4} />
                <GridItem col={12} laptop={4}>
                    <DisplayH1><Trans t={t}>error404Title</Trans></DisplayH1>
                    <Body2><Trans t={t}>error404Description</Trans></Body2>
                </GridItem>
                <GridItem col={0} laptop={4} />
            </GridRow>
        </GridContainer>
    </InformatDefaultPage>
}
